import { render, staticRenderFns } from "./123.vue?vue&type=template&id=055776f3&scoped=true&"
import script from "./123.vue?vue&type=script&lang=js&"
export * from "./123.vue?vue&type=script&lang=js&"
import style0 from "./123.vue?vue&type=style&index=0&id=055776f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055776f3",
  null
  
)

export default component.exports